const doc = [({"da":({"models":({"organization_user_relationship":({"student":"Elev", "teacher":"Underviser", "father":"Far", "leader":"Leder", "mother":"Mor", "other":"Andet"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;